import { render } from "./document_submission.html?vue&type=template&id=5f7f40ce&external"
import script from "./document_submission.js?vue&type=script&lang=js&external"
export * from "./document_submission.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__